(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';

function _mapActivityObservation(observation) {
  var datePeriod = null;
  var steps = null;
  var distance = null;
  var calories = null;

  var _ref = observation.effectivePeriod || {},
      start = _ref.start,
      end = _ref.end;

  if (start && end) {
    datePeriod = {
      start: moment(start).local(),
      end: moment(end).local()
    };
  }

  if (!datePeriod) {
    return null;
  }

  var component = observation.component;
  component.forEach(function (componentItem) {
    var componentCode = componentItem.code,
        valueQuantity = componentItem.valueQuantity;

    var _ref2 = componentCode || {},
        coding = _ref2.coding;

    var _ref3 = coding && !!coding.length && coding[0] || {},
        code = _ref3.code,
        system = _ref3.system;

    var _ref4 = valueQuantity || {},
        value = _ref4.value,
        _ref4$unit = _ref4.unit,
        unit = _ref4$unit === void 0 ? '' : _ref4$unit;

    if (!code || !system || !value) {
      return;
    }

    if (system === 'http://loinc.org' && code === '55423-8') {
      steps = value;
    } else if (system === 'http://loinc.org' && code === '55430-3') {
      distance = "".concat(value, " ").concat(unit);
    } else if (system === 'http://loinc.org' && code === '55421-2') {
      calories = "".concat(value, " ").concat(unit);
    }
  });

  if (!steps && !distance && !calories) {
    return null;
  }

  return {
    id: observation.id,
    datePeriod: datePeriod,
    steps: steps,
    distance: distance,
    calories: calories
  };
}

export default function mapFromFHIR(observationBundleEntry) {
  var activities = [];
  observationBundleEntry.forEach(function (bundleEntry) {
    var observation = bundleEntry.resource;

    var activity = _mapActivityObservation(observation);

    if (!activity) {
      return;
    }

    activities.push(activity);
  });
  return activities;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_mapActivityObservation, "_mapActivityObservation", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(mapFromFHIR, "mapFromFHIR", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/mappers/mapFromFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();